import { configs } from "./prod.cofigs";
import { dev_configs } from "./dev.configs";


export const app_configs = window.location.origin === 'http://localhost:3000' ? dev_configs : configs;